
import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { datadogRum } from "@datadog/browser-rum";
import { reactPlugin } from "@datadog/browser-rum-react";

const runtimeConfig = window.__RUNTIME_CONFIG__ || {};

datadogRum.init({
    applicationId: "bf3d1390-0f80-48ef-be5b-6594a667ec21",
    clientToken: "pub0d1966d5c684d28bd82a104816e77564",
    site: "ap2.datadoghq.com",
    service: "legacy-seller-portal",
    env: runtimeConfig.REACT_APP_ENVIRONMENT,
    sessionSampleRate: 100,
    sessionReplaySampleRate: 40,
    defaultPrivacyLevel: "mask-user-input",
    plugins: [reactPlugin({ router: true })],
    trackUserInteractions: true,
    allowedTracingUrls: [
        /^https:\/\/[^\/]+\.woolworthsmarketplus\.com\.au/
    ]
});

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement,
);

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
